<script>
import ClickOut from '../../../../utils/directives/clickout'
import {uploadArquivo} from '../../../../domain/policia-civil/pericia/services/pericia'
import {fileToBase64} from '../../../_default/utils/fileToBase64'
import {getPublicLinkS3} from '../../../../domain/grv/services'

const TIPO_ARQUIVO_PERICIA = 7

export default{
  name: 'BtnMenuPericia',
  props: {
    grv: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false,
      loading: false,
      items: [
        {
          label: '',
          icon: '',
          emitEvent: '',
          event: ''
        }
      ]
    }
  },
  computed: {
    isPericiaArquivoPdf () {
      return this.grv.arquivos.some(a => a.tipo === TIPO_ARQUIVO_PERICIA)
    }
  },
  created () {
    this.montaItens()
  },
  mounted () { },
  destroyed () { },
  methods: {
    toggle () {
      this.open = !this.open
    },
    hide () {
      this.open = false
    },
    handleClick ({emitEvent, event: fn}) {
      if (fn) return this[fn]()
      return this.$emit(emitEvent)
    },
    montaItens () {
      const items = []
      const {periciaRealizada} = this.grv
      const itemForm = {
        label: `${periciaRealizada ? 'Acessar / Editar' : 'Cadastrar'} Perícia`,
        icon: `${periciaRealizada ? 'edit' : 'plus'}`,
        emitEvent: 'openFormPericia'
      }
      const itemArquivo = {
        label: `${periciaRealizada ? 'Visualizar' : 'Upload'} Arquivo Perícia`,
        icon: `${periciaRealizada ? 'download' : 'upload'}`,
        event: `${periciaRealizada ? 'downloadDocumento' : 'openMultipleInputFile'}`
      }

      if (periciaRealizada) {
        items.push(this.isPericiaArquivoPdf ? itemArquivo : itemForm)
      } else {
        items.push(itemArquivo, itemForm)
      }
      this.items = items
    },
    openMultipleInputFile () {
      this.$refs['uploadPericia'].click()
    },
    uploadDocumento: async function (e) {
      this.loading = true
      this.open = false
      const file = await fileToBase64(e.target.files[0])
      try {
        await uploadArquivo(this.grv.id, {data: file, filename: 'arquivoPericia'})
        this.$emit('reload')
      } catch (error) {
        console.log('Erro ao enviar o arquivo: ', error)
      } finally {
        this.montaItens()
        this.clearInputFiles()
        this.loading = false
      }
    },
    downloadDocumento () {
      this.$loaderOverlay.open()
      const arquivo = this.grv.arquivos.find(a => a.tipo === TIPO_ARQUIVO_PERICIA)
      getPublicLinkS3(arquivo.id)
        .then(response => {
          const link = document.createElement('a')
          link.href = `${process.env.API_URL}${response.data}`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert('Ocorreu um erro ao acessar a imagem, tente novamente')
          this.$loaderOverlay.hide()
          console.log(error)
        })
    },
    clearInputFiles () {
      if (this.$refs.uploadPericia) {
        this.$refs.uploadPericia.value = ''
      }
    }
  },
  directives: {ClickOut}
}
</script>

<template>
  <div class="btn-group dropdown" :class="{open: open}"  v-click-out="hide">
    <button type="button" @click.stop.prevent="" class="btn btn-md btn-default" data-toggle="dropdown" tabindex="1" aria-expanded="false" v-if="loading">
      <i class="fa fa-spinner fa-spin m-r-xs"></i>
    </button>
    <button class="btn btn-md btn-default" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle" v-else>
      <i class="fa fa-certificate m-r-xs"></i> Perícia DRFA <span class="caret"></span>
    </button>
    <ul class="dropdown-menu no-padder">
      <li v-for="(item, key) in items">
        <a @click.prevent="handleClick(item)"  :tabindex="key"><i :class="`fa fa-${item.icon} fa-fw`"></i> {{ item.label }} </a>
      </li>
    </ul>
    <input type="file" name="files[]" id="fileInptImg" ref="uploadPericia" @change="uploadDocumento" v-show="false" accept="application/pdf">
  </div>
</template>



// WEBPACK FOOTER //
// BtnMenuPericia.vue?d775dc4e